import classNames from 'classnames'
import { ITableClasses } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/styledTable/StyledTable'
import { isValidElement } from 'react'

import { IColumn } from './types'

import styles from './StyledTable.module.scss'

interface IProps<T> {
  rowIndex: number
  columns: IColumn<T>[]
  item: T
  deleteRow?: (index: number) => void
  keyField?: string
  classes: ITableClasses
}

const getTdStyle = <T,>(col: IColumn<T>) => {
  if (!col.width) {
    return {}
  }
  return { style: { width: col.width } }
}

export function Row<T>({ columns, item, rowIndex, deleteRow, keyField, classes }: IProps<T>) {
  const keyValue = keyField ? item[keyField] : ''

  return (
    <tr className={classNames(styles.row, classes.tr)}>
      {columns.map((col, index) => {
        const value = item[col.field]
        const content = col.renderComponent
          ? col.renderComponent({ value, index: rowIndex, keyValue })
          : typeof value === 'string' || typeof value === 'number' || isValidElement(value)
            ? value
            : null

        return (
          <td className={classNames(styles.col, classes.td)} {...getTdStyle<T>(col)} key={index}>
            <>
              {content}
              {deleteRow && index === columns.length - 1 ? (
                <i
                  onClick={() => deleteRow(rowIndex)}
                  className={classNames('kbase kbase-close', styles.icon, classes.deleteIcon)}
                />
              ) : null}
            </>
          </td>
        )
      })}
    </tr>
  )
}
